import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const CRM = lazy(() => import('../pages/crm/page'));
const FunilComercial = lazy(() => import('../pages/funil-comercial/page'));
const Financeiro = lazy(() => import('../pages/financeiro/page'));
const ClientesEmpresas = lazy(() => import('../pages/clientes-e-empresas/page'));
const Consultores = lazy(() => import('../pages/consultores/page'));
const Comunicacao = lazy(() => import('../pages/comunicacao/page'));
const Propostas = lazy(() => import('../pages/propostas/page'));
const Parceiros = lazy(() => import('../pages/parceiros/page'));
const FunilParcerias = lazy(() => import('../pages/funil-parcerias/page'));
const Startups = lazy(() => import('../pages/startups/page'));
const Investidores = lazy(() => import('../pages/investidores/page'));
const Automacoes = lazy(() => import('../pages/automacoes/page'));
const Configuracoes = lazy(() => import('../pages/configuracoes/page'));
const Eventos = lazy(() => import('../pages/eventos/page'));
const DashboardsPersonalizados = lazy(() => import('../pages/dashboards-personalizados/page'));
const Relatorios = lazy(() => import('../pages/relatorios/page'));
const Metricas = lazy(() => import('../pages/metricas/page'));
const EditaisFomento = lazy(() => import('../pages/editais-fomento/page'));
const EditaisFomentoDashboard = lazy(() => import('../pages/editais-fomento/dashboard/page'));
const DiagnosticoExemplo = lazy(() => import('../pages/diagnostico-exemplo/page'));
const Gestao = lazy(() => import('../pages/gestao/page'));
const Home = lazy(() => import('../pages/home/page'));
const Empresas = lazy(() => import('../pages/empresas/page'));
const Cadastro = lazy(() => import('../pages/cadastro/page'));

// X Lab Studio components
const XLabStudio = lazy(() => import('../pages/xlab-studio/page'));
const XLabStudioAdmin = lazy(() => import('../pages/xlab-studio/admin/page'));
const XLabStudioAdminProjects = lazy(() => import('../pages/xlab-studio/admin/projects/page'));
const XLabStudioAdminClients = lazy(() => import('../pages/xlab-studio/admin/clients/page'));
const XLabStudioAdminConsulting = lazy(() => import('../pages/xlab-studio/admin/consulting/page'));
const XLabStudioAdminTemplates = lazy(() => import('../pages/xlab-studio/admin/templates/page'));
const XLabStudioClient = lazy(() => import('../pages/xlab-studio/client/page'));
const XLabStudioClientLogin = lazy(() => import('../pages/xlab-studio/client/login/page'));
const XLabStudioClientPortal = lazy(() => import('../pages/xlab-studio/client/portal/page'));

// Error page
const NotFound = lazy(() => import('../pages/NotFound'));

// Protected Route component
import ProtectedRoute from '../components/ProtectedRoute';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/cadastro',
    element: <Cadastro />
  },
  {
    path: '/home',
    element: <ProtectedRoute><Home /></ProtectedRoute>
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute><Dashboard /></ProtectedRoute>
  },
  {
    path: '/crm',
    element: <ProtectedRoute><CRM /></ProtectedRoute>
  },
  {
    path: '/funil-comercial',
    element: <ProtectedRoute><FunilComercial /></ProtectedRoute>
  },
  {
    path: '/financeiro',
    element: <ProtectedRoute><Financeiro /></ProtectedRoute>
  },
  {
    path: '/clientes-e-empresas',
    element: <ProtectedRoute><ClientesEmpresas /></ProtectedRoute>
  },
  {
    path: '/consultores',
    element: <ProtectedRoute><Consultores /></ProtectedRoute>
  },
  {
    path: '/comunicacao',
    element: <ProtectedRoute><Comunicacao /></ProtectedRoute>
  },
  {
    path: '/propostas',
    element: <ProtectedRoute><Propostas /></ProtectedRoute>
  },
  {
    path: '/parceiros',
    element: <ProtectedRoute><Parceiros /></ProtectedRoute>
  },
  {
    path: '/funil-parcerias',
    element: <ProtectedRoute><FunilParcerias /></ProtectedRoute>
  },
  {
    path: '/startups',
    element: <ProtectedRoute><Startups /></ProtectedRoute>
  },
  {
    path: '/investidores',
    element: <ProtectedRoute><Investidores /></ProtectedRoute>
  },
  {
    path: '/automacoes',
    element: <ProtectedRoute><Automacoes /></ProtectedRoute>
  },
  {
    path: '/configuracoes',
    element: <ProtectedRoute><Configuracoes /></ProtectedRoute>
  },
  {
    path: '/eventos',
    element: <ProtectedRoute><Eventos /></ProtectedRoute>
  },
  {
    path: '/dashboards-personalizados',
    element: <ProtectedRoute><DashboardsPersonalizados /></ProtectedRoute>
  },
  {
    path: '/relatorios',
    element: <ProtectedRoute><Relatorios /></ProtectedRoute>
  },
  {
    path: '/metricas',
    element: <ProtectedRoute><Metricas /></ProtectedRoute>
  },
  {
    path: '/editais-fomento',
    element: <ProtectedRoute><EditaisFomento /></ProtectedRoute>
  },
  {
    path: '/editais-fomento/dashboard',
    element: <ProtectedRoute><EditaisFomentoDashboard /></ProtectedRoute>
  },
  {
    path: '/diagnostico-exemplo',
    element: <ProtectedRoute><DiagnosticoExemplo /></ProtectedRoute>
  },
  {
    path: '/gestao',
    element: <ProtectedRoute><Gestao /></ProtectedRoute>
  },
  {
    path: '/empresas',
    element: <ProtectedRoute><Empresas /></ProtectedRoute>
  },
  // X Lab Studio routes
  {
    path: '/xlab-studio',
    element: <ProtectedRoute><XLabStudio /></ProtectedRoute>
  },
  {
    path: '/xlab-studio/admin',
    element: <ProtectedRoute><XLabStudioAdmin /></ProtectedRoute>
  },
  {
    path: '/xlab-studio/admin/projects',
    element: <ProtectedRoute><XLabStudioAdminProjects /></ProtectedRoute>
  },
  {
    path: '/xlab-studio/admin/clients',
    element: <ProtectedRoute><XLabStudioAdminClients /></ProtectedRoute>
  },
  {
    path: '/xlab-studio/admin/consulting',
    element: <ProtectedRoute><XLabStudioAdminConsulting /></ProtectedRoute>
  },
  {
    path: '/xlab-studio/admin/templates',
    element: <ProtectedRoute><XLabStudioAdminTemplates /></ProtectedRoute>
  },
  {
    path: '/xlab-studio/client',
    element: <ProtectedRoute><XLabStudioClient /></ProtectedRoute>
  },
  {
    path: '/xlab-studio/client/login',
    element: <XLabStudioClientLogin />
  },
  {
    path: '/xlab-studio/client/portal',
    element: <ProtectedRoute><XLabStudioClientPortal /></ProtectedRoute>
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
